import { Label } from '@/components/ui/label';
import { useTranslation } from '@/i18n';
import clsx from 'clsx';
import {
  agencyMutedFieldBoxClass,
  agencyMutedLabelClass,
} from '@/utils/estimates/agencyMutedFieldStyles';

interface AgencyOverlayPlaceholderFieldProps {
  label?: string;
  muted?: boolean;
  className?: string;
}

/** Read-only placeholder shown to the TO instead of agency overlay values. */
const AgencyOverlayPlaceholderField = ({
  label,
  muted = false,
  className,
}: AgencyOverlayPlaceholderFieldProps) => {
  const { t } = useTranslation();

  return (
    <div className={clsx('space-y-1.5', className)}>
      {label ? (
        <Label className={muted ? agencyMutedLabelClass : 'text-gray-700'}>
          {label}
        </Label>
      ) : null}
      <div
        className={clsx(
          'flex h-10 items-center text-base',
          agencyMutedFieldBoxClass,
          muted ? 'text-gray-500' : 'text-gray-700',
        )}
        aria-hidden
      >
        {t('estimates.agencyView.hiddenValue')}
      </div>
    </div>
  );
};

export default AgencyOverlayPlaceholderField;
